import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";

const TBody = props => {
  const { children, className } = props;

  return (
    // <div
    //   className={cn(
    //     "responsive-table__tbody",
    //     className
    //   )}
    // >
    //   {children}
    // </div>
    <tbody className={cn("responsive-table__tbody", className)}>
      {children}
    </tbody>
  );
};

TBody.propsType = {
  children: PropTypes.node,
  className: PropTypes.string
};

export default TBody;



// WEBPACK FOOTER //
// ./src/containers/responsive-table/tbody.js